import { Button as ADButton, type ButtonProps as ADButtonProps } from 'antd';
import { type FC, forwardRef } from 'react';

interface ButtonProps extends Omit<ADButtonProps, 'variant'> {
  buttonType?: ADButtonProps['htmlType'];
  fullWidth?: boolean;
  invertMode?: boolean;
  lightMode?: boolean;
  id?: string;
  dataTestId?: string;
  // TODO: custom variant props shouldn't match antd button props
  variant?: string;
}

const Button: FC<ButtonProps> = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      onClick = () => {},
      loading = false,
      size = 'small',
      className = '',
      type = 'primary',
      variant = 'primary',
      buttonType = 'button',
      fullWidth,
      invertMode = false,
      lightMode,
      id,
      disabled,
      dataTestId = '',
      ...rest
    },
    ref,
  ) => {
    return (
      <ADButton
        id={id}
        className={`common-button ${
          fullWidth ? 'w-100' : ''
        } ${className} variant-${variant} ${invertMode ? 'invert-mode' : ''} ${lightMode ? 'light-mode' : ''}`}
        type={type}
        loading={loading}
        onClick={onClick}
        size={size}
        htmlType={buttonType}
        {...rest}
        disabled={disabled}
        data-testid={dataTestId}
        ref={ref}
      >
        {children}
      </ADButton>
    );
  },
);

Button.displayName = 'Button';

export default Button;
